import React, { useEffect } from "react";
import "./MainHeading.css";

const MainHeading1 = (props) => {
  console.log(props);
  return (
    <div className="main-heading">
      <h1 className="main-heading-text">
        {props.heading}
        <br />
        {props.heading2}
      </h1>
    </div>
  );
};

export default MainHeading1;
// the mac book issue
//
